
import Vue from 'vue';

import RuleInfoDialog from '@/components/entities/rule/RuleInfoDialog.vue';
import RuleEditDialog from '@/components/entities/rule/RuleEditDialog.vue';
import RuleDeleteDialog from '@/components/entities/rule/RuleDeleteDialog.vue';
import { objectsToCSV, filterItem } from '@/utils/Util';

export default Vue.extend({
  name: 'RulesTable',

  components: {
    RuleInfoDialog,
    RuleEditDialog,
    RuleDeleteDialog,
  },

  props: ['rules', 'loading'],

  data: (vm: any): any => ({
    tableLoadingText: vm.loadingText,
    search: '',
    numberOfEntities: 0,
    selectedHeaders: [
      { text: vm.$t('attribute.name'), value: 'name', index: 1 },
      { text: vm.$t('attribute.description'), value: 'description', index: 2 },
      {
        text: vm.$t('rule.scopeEntityType'),
        value: 'scopeEntityType',
        index: 3,
      },
      { text: vm.$t('attribute.createdAt'), value: 'createdAt', index: 8 },
      { text: vm.$t('attribute.updatedAt'), value: 'updatedAt', index: 9 },
    ],
  }),

  created() {
    if (this.rules.length === 0) {
      this.tableLoadingText = this.$t('rule.noData');
    }

    const columns = this.$root.$store.getters.selectedColumns('rules');
    if (columns) {
      this.selectedHeaders = columns;
    }
  },

  methods: {
    filterItem,
    onReload() {
      this.$emit('reload');
    },
    onRuleItemUpdate(item: any) {
      this.$emit('update', item);
    },
    onRuleItemDelete(item: any) {
      this.$emit('delete', item);
    },
    onPaginationAndFilter(pagination: any) {
      this.numberOfEntities = pagination.itemsLength;
    },
    onTableRowClick(row: any) {
      const button: any = this.$refs['ruleInfoButton_' + row.uuid];
      if (button && button.$el) {
        button.$el.click();
      }
    },
    onExport() {
      let filteredItems = this.rules;
      const internal = (this.$refs.dataTable as any).$children[0];
      if (internal && internal.filteredItems) {
        filteredItems = internal.filteredItems;
      }

      const data = filteredItems.map((rule: any) =>
        Object({
          uuid: rule.uuid,
          name: rule.name,
          description: rule.description,
          scopeEntityType: rule.scopeEntityType,
          createdAt: rule.createdAt,
          updatedAt: rule.updatedAt,
        })
      );

      const filename = 'bascloud_rules.csv';
      const csvContent = objectsToCSV(data);
      const blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;',
      });

      if ((navigator as any).msSaveBlob) {
        (navigator as any).msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
  },
  watch: {
    selectedHeaders() {
      this.$store.commit('setSelectedColumns', {
        type: 'rules',
        columns: this.selectedHeaders,
      });
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t('attribute.uuid'), value: 'uuid', index: 0 },
        { text: this.$t('attribute.name'), value: 'name', index: 1 },
        {
          text: this.$t('attribute.description'),
          value: 'description',
          index: 2,
        },
        {
          text: this.$t('rule.scopeEntityType'),
          value: 'scopeEntityType',
          index: 3,
        },
        { text: this.$t('attribute.createdAt'), value: 'createdAt', index: 8 },
        { text: this.$t('attribute.updatedAt'), value: 'updatedAt', index: 9 },
      ];
    },
    loadingText(): any {
      return this.$t('loadingData');
    },
    computedTableHeader(): any {
      return [
        ...this.selectedHeaders,
        {
          text: this.$t('attribute.actions'),
          value: 'actions',
          sortable: false,
          filterable: false,
          index: 100,
        },
      ].sort((a: any, b: any) => a.index - b.index);
    },
    canUpdate(): any {
      if (
        this.$root.$store.state.session.permissions.resources &&
        'rules' in this.$root.$store.state.session.permissions.resources
      ) {
        return this.$root.$store.state.session.permissions.resources[
          'rules'
        ].includes('PATCH');
      } else {
        return false;
      }
    },
    canDelete(): any {
      if (
        this.$root.$store.state.session.permissions.resources &&
        'rules' in this.$root.$store.state.session.permissions.resources
      ) {
        return this.$root.$store.state.session.permissions.resources[
          'rules'
        ].includes('DELETE');
      } else {
        return false;
      }
    },
  },
});
